import {VIEW_JOBLIST_REQUEST,VIEW_JOBLIST_SUCCESS,VIEW_JOBLIST_FAIL} from "../constants/AuthConstant"
import axios from "axios";

export const GetAllJobList = ({pageNumber,size,search,activeTab}) => {
    return function (dispatch) {
        dispatch({
        type: VIEW_JOBLIST_REQUEST,
        payload: true,
        });
        
        let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_all_jobs?pageNumber=${pageNumber}&pageSize=${size}&search=${search}&jobPostedStatus=${activeTab}`,
        method: "GET",
        headers: {
            "content-type": "application/json",
        },
        };
        axios(OPTION)
        .then((res) => {
            // console.log(res.data,"helloView")
            dispatch(loadAllDetailsPreJobs(res.data));
        })
        .catch((error) => {
            dispatch({
            type: VIEW_JOBLIST_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
            });
        });
    };
}
    
export const loadAllDetailsPreJobs = (data) => {
return {
    type: VIEW_JOBLIST_SUCCESS,
    result: data,
    payload: false,
    msg: "SUCCESS",
};
};
